export class nullInt{
	Int : number
	Valid  : boolean
}